import calculateEndBookingDate from './calculateEndBookingDate';

const getEndDate = (publicData) => {
  const endBookingDate = calculateEndBookingDate(publicData);
  return endBookingDate ? endBookingDate.valueOf() : null;
};

export default getEndDate;
